// the Uniswap Default token list lives here
export const DEFAULT_TOKEN_LIST_URL =
  'https://gist.githubusercontent.com/mmc-98/a4595f462695c7e981638e68a3df7980/raw/4c74797507e8d383f4d903b2e083ef5b2739356c/local.json'

export const DEFAULT_LIST_OF_LISTS: string[] = [DEFAULT_TOKEN_LIST_URL]
